import React from "react";

const Team = props => {

  return (
    <React.Fragment>
      {/* <!--========================== */}
      {/* Team Section */}
      {/* ============================--> */}
      <section id="team" className="padd-section text-center wow fadeInUp">

        <div className="container">
          <div className="section-title text-center">

            <h2>Team Member</h2>
            <p className="separator">Integer cursus bibendum augue ac cursus .</p>

          </div>
        </div>

        <div className="container">
          <div className="row">

            <div className="col-md-6 col-md-4 col-lg-3">
              <div className="team-block bottom">
                <img src="img/team/1.jpg" className="img-responsive" alt="img" />
                <div className="team-content">
                  <ul className="list-unstyled">
                    <li><a href="/"><i className="fa fa-facebook"></i></a></li>
                    <li><a href="/"><i className="fa fa-twitter"></i></a></li>
                    <li><a href="/"><i className="fa fa-linkedin"></i></a></li>
                  </ul>
                  <span>manager</span>
                  <h4>Kimberly Tran</h4>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-md-4 col-lg-3">
              <div className="team-block bottom">
                <img src="img/team/2.jpg" className="img-responsive" alt="img" />
                <div className="team-content">
                  <ul className="list-unstyled">
                    <li><a href="/"><i className="fa fa-facebook"></i></a></li>
                    <li><a href="/"><i className="fa fa-twitter"></i></a></li>
                    <li><a href="/"><i className="fa fa-linkedin"></i></a></li>
                  </ul>
                  <span>manager</span>
                  <h4>Kimberly Tran</h4>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-md-4 col-lg-3">
              <div className="team-block bottom">
                <img src="img/team/3.jpg" className="img-responsive" alt="img" />
                <div className="team-content">
                  <ul className="list-unstyled">
                    <li><a href="/"><i className="fa fa-facebook"></i></a></li>
                    <li><a href="/"><i className="fa fa-twitter"></i></a></li>
                    <li><a href="/"><i className="fa fa-linkedin"></i></a></li>
                  </ul>
                  <span>manager</span>
                  <h4>Kimberly Tran</h4>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-md-4 col-lg-3">
              <div className="team-block bottom">
                <img src="img/team/4.jpg" className="img-responsive" alt="img" />
                <div className="team-content">
                  <ul className="list-unstyled">
                    <li><a href="/"><i className="fa fa-facebook"></i></a></li>
                    <li><a href="/"><i className="fa fa-twitter"></i></a></li>
                    <li><a href="/"><i className="fa fa-linkedin"></i></a></li>
                  </ul>
                  <span>manager</span>
                  <h4>Kimberly Tran</h4>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

    </React.Fragment>
  );
}
export default Team;